import axios, { getData } from "../../../axios";
import { createSlice } from "@reduxjs/toolkit";
import * as tPromise from "io-ts-promise";
import { documentsT, Document } from "./types";
import { createErrorReportingAsyncThunk } from "../../helpers";
import { handleCargoDeletedWhileLoading } from "../../app/cargo-dialog";

const prefix = "/data/cargo-documents";

export const loadDocuments = createErrorReportingAsyncThunk(
  `${prefix}/load`,
  (cargoId: string, thunkAPI): Promise<Document[]> =>
    axios
      .get(`/api/cargos/${cargoId}/documents`)
      .then(getData)
      .then(tPromise.decode(documentsT))
      .catch((e) => {
        if (handleCargoDeletedWhileLoading(e, thunkAPI, cargoId)) {
          return [];
        }
        throw e;
      })
);

type State = {
  byCargoId: Record<string, Document[] | undefined>;
};

const initialState: State = {
  byCargoId: {},
};

const slice = createSlice({
  name: prefix,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadDocuments.fulfilled, (state, action) => {
      state.byCargoId[action.meta.arg] = action.payload;
    });
  },
});

export default slice.reducer;
